import { Component, Input } from '@angular/core';
import {
  TenderEvaluationCommitteeDTO,
  MemberProcurementCommitteeDTO,
  TenderingPhaseDTO,
  ProcurementCommitteeDTO
} from '../../api/plyca-dtos';
import { Configuration } from '../../conf/app.constants';
import { TenderingBaseComponent } from './tenderingBase.component';
import { Observable } from 'rxjs';
import { HelpType } from '../../components/common/help/help.service';

@Component({
  selector: 'tenderingCommittes',
  templateUrl: 'tenderingCommittes.template.html'
})
export class TenderingCommittesComponent extends TenderingBaseComponent<
  TenderEvaluationCommitteeDTO
> {
  @Input()
  private tenderingPhases: Array<TenderingPhaseDTO>;

  constructor(private configuration: Configuration) {
    super();
    this.colHeaders = [
      'General.name',
      'TenderEvaluationCommittee.number_quorum',
      'General.actions'
    ];
  }
  getServiceURL(): string {
    return this.configuration.TENDEREVALCOMMITTEE_SERVICE_URL;
  }
  getTagsIdentifier(): string[] {
    return [HelpType.EDIT_ORG_COLEGIADO];
  }
  getFormSettingURL(): string {
    return 'tenderEvaluationCommitteeSettings.json';
  }
  getDialogTitle(): string {
    return 'TenderEvaluationCommittee.edit.title';
  }
  dtoToBean(dto: TenderEvaluationCommitteeDTO) {
    return dto;
  }
  beanToDTO(bean: any): TenderEvaluationCommitteeDTO {
    const taskId = this.task?.identifier;
    if (bean) {
      bean.task = {
        identifier: taskId
      }
    }
    if (bean.memberTenderEvaluationCommittee) {
      bean.memberTenderEvaluationCommittee.forEach(
        (committee: MemberProcurementCommitteeDTO) => {
          delete committee.parent;
          delete committee['_parent'];
        }
      );
    }
    return bean;
  }

  public canDelete(committee: TenderEvaluationCommitteeDTO): boolean {
    let isCommitteeAsignedToEvent = false;
    if (this.tenderingPhases) {
      isCommitteeAsignedToEvent =
        this.tenderingPhases.find(
          (phase: TenderingPhaseDTO) =>
            phase.openingCommittees &&
            phase.openingCommittees.find(
              (phaseCommittee: ProcurementCommitteeDTO) =>
                phaseCommittee.evaluationCommittee &&
                phaseCommittee.evaluationCommittee.identifier ===
                committee.identifier
            ) !== undefined
        ) !== undefined;
    }
    return !isCommitteeAsignedToEvent;
  }
}
